// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-placeholder {
  width: 720px;
  max-height: 90vh;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
}
.dialog-placeholder__body-container {
  max-height: 100%;
  max-width: 100%;
  overflow-y: auto;
}
.dialog-placeholder__title-popover {
  vertical-align: middle;
  margin-left: 5px;
}
.dialog-placeholder__min-input, .dialog-placeholder__max-input {
  width: 75px;
}
.dialog-placeholder__title-setting-container {
  display: flex;
  align-items: center;
}
.dialog-placeholder__title-radio-buttons {
  width: 235px;
}
.dialog-placeholder__title-input {
  width: 235px;
  margin-left: 15px;
}
.dialog-placeholder__grid-step-input {
  width: 155px;
}
.dialog-placeholder__title-icon {
  margin-right: 4px;
  margin-bottom: 2px;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/DialogPlaceholder/DialogPlaceholder.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AACJ;AACI;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;AACR;AAEI;EACI,sBAAA;EACA,gBAAA;AAAR;AAGI;EAEI,WAAA;AAFR;AAKI;EACI,aAAA;EACA,mBAAA;AAHR;AAMI;EACI,YAAA;AAJR;AAOI;EACI,YAAA;EACA,iBAAA;AALR;AAQI;EACI,YAAA;AANR;AASI;EACI,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPR","sourcesContent":[".dialog-placeholder {\n  width: 720px;\n  max-height: 90vh;\n  overflow-y: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.dialog-placeholder__body-container {\n  max-height: 100%;\n  max-width: 100%;\n  overflow-y: auto;\n}\n.dialog-placeholder__title-popover {\n  vertical-align: middle;\n  margin-left: 5px;\n}\n.dialog-placeholder__min-input, .dialog-placeholder__max-input {\n  width: 75px;\n}\n.dialog-placeholder__title-setting-container {\n  display: flex;\n  align-items: center;\n}\n.dialog-placeholder__title-radio-buttons {\n  width: 235px;\n}\n.dialog-placeholder__title-input {\n  width: 235px;\n  margin-left: 15px;\n}\n.dialog-placeholder__grid-step-input {\n  width: 155px;\n}\n.dialog-placeholder__title-icon {\n  margin-right: 4px;\n  margin-bottom: 2px;\n  height: 24px;\n  width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
